import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Link, Option, SignOut } from './StyledComponents.jsx';

const RegisteredUserOptions = ({ onSwitchBoardsClick, userType }) => {
  const { t } = useTranslation('header');
  return (
    <Fragment>
      <Option onClick={() => onSwitchBoardsClick()}>
        {t('account.switchBoards')}
      </Option>

      <Link href="/account/settings/edit">
        <Option>{t('account.settings')}</Option>
      </Link>

      {userType === 'site admin' && (
        <Link href="/admin">
          <Option>{t('account.siteAdmin')}</Option>
        </Link>
      )}

      <Link id="signOut" rel="nofollow" data-method="delete" href="/sign_out">
        <SignOut>{t('account.signOut')}</SignOut>
      </Link>
    </Fragment>
  );
};

export default RegisteredUserOptions;
